// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2VFtA","title":"styles_title__31A8J"};